let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b9sUh")).then(() => parcelRequire('7OlYu'));